import React from 'react';

const IncomeTypeContext = React.createContext(["", () => {}]);

export default IncomeTypeContext;
